<template>
  <div>
    <b-row class="mt-5">
      <b-col xxs="12" class="mx-auto">
      

        <b-card  class=" mb-5">

          <div class="row">
            <div class="col-6">
              <h2 class="font-weight-bold m-0">API User Guide</h2>
              <h6 class="mb-3 text-muted">{{ appName }}</h6>
            </div>
            <div class="col-6 text-right">
              <img src="@/assets/img/logo.png" height="60" class="mb-3" />
            </div>
          </div>

            
              <hr>

          <div class="row">
            <div class="col-12">

       
                <h4>REST API</h4>
                <p>Content-Type : application/json<br>
                <small class="text-black-50">-Authorization with API key in request body</small>
                </p>
                <br>

                <h4 class="border p-2 d-inline">Mark an order as fulfilled</h4><br><br>
                <div class="bg-light d-inline p-2 mt-2">
                <strong class="btn btn-info btn-sm">POST</strong>  https://glrt.api.zyelabs.net/api/shopify/order-fulfilled
                </div>

                <br> <br>
                
               
                  <code>
                     
                  { <br>
                    &nbsp;&nbsp; "api_key":"123ABC", <br>
                    &nbsp;&nbsp; "shopify_order_number":"123467" <br>
                    &nbsp;&nbsp; "warehouse_id":"45674" <br>
                  }
                   
                  </code>
            
                <br>
                [Warehouse ID s Optional at Present, pass an empty string if not used ]<br>
                [API Key,Shopify Order Number and Warehouse ID are of type string]<br>
                [Sample order number that be used:<strong> 123467</strong>]
                <br><br>
                

                <p class="font-weight-bold">-RESPONSE (status 201)</p>
               <code>
                {<br>
                   &nbsp;&nbsp; "message":"success",<br>
                   &nbsp;&nbsp;  "shopify_order_number":"123467"<br>
                }
                </code>
                <br><br>

                 <p class="font-weight-bold">-RESPONSE (status 404)</p>
               <code>
                {<br>
                    "message":"order not found",<br>
                    "shopify_order_number":"123467"<br>
                }
                  </code>
               
               <br><br><br>

                <h4>Sandox - Testing</h4>
                <div class="bg-light d-inline p-2 mt-2">
                <strong class="btn btn-info btn-sm">POST</strong>  https://glrt.api.zyelabs.net/api/shopify/sandbox/order-fulfilled
                </div>
                <br><br>
                [Use sandbox api key, and any valid shopify order number]
                <br><br>

              
            </div>
          </div>
         
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME
    };
  }
};
</script>
